import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { InfoOrderDetailTypes, EmployedsInfoTypes } from './types';
import { getDateFormattedDateForParams } from 'utils/date';

interface HourMinutesTypes {
  hour: string;
  minutes: string;
}

interface StateType {
  infoOrderDetail: InfoOrderDetailTypes;
  employedInfo: EmployedsInfoTypes;
  dateStart: any;
  dateEnd: any;
  dateStartHourMinutes: HourMinutesTypes;
  dateEndHourMinutes: HourMinutesTypes;
}

const getDefaultFastWithdrawal = (): boolean => {
  try {
    const profileData = localStorage.getItem('profile_settings');
    if (profileData) {
      const settings = JSON.parse(profileData);
      return settings?.use_fast_withdraw || false;
    }
  } catch (e) {
    console.log('Ошибка при получении настроек из localStorage', e);
  }
  return false;
};

const createInitialOrderDetail = (): InfoOrderDetailTypes => ({
  order_type_id: 0,
  description: '',
  // date_start: new Date(),
  // date_end: new Date(),
  date_start: '',
  date_end: '',
  amount: '',
  unit_price: '',
  unit_volume: 1,
  total_price: '',
  unit_measure: '',
  is_unit_based: false,
  unit_volume_min: 1,
  unit_volume_max: '',
  is_remote: 'Удаленно',
  city: '',
  street: '',
  home: '',
  apartment: '',
  worker_id: null,
  is_draft: 0,
  accept_automatically: 0,
  order_preset_id: null,
  add_tax_amount: false,
  with_date_start: false,
  with_date_end: false,
  with_address: false,
  use_fast_withdraw: getDefaultFastWithdrawal(),
});

const initialState: StateType = {
  infoOrderDetail: createInitialOrderDetail(),
  employedInfo: {
    name: '',
    inn: '',
    status: 1,
    phone: '',
  },
  dateStart: new Date(),
  dateEnd: new Date(),
  dateStartHourMinutes: {
    hour: '00',
    minutes: '00',
  },
  dateEndHourMinutes: {
    hour: '00',
    minutes: '00',
  },
};

export const ordersDetailsSlice = createSlice({
  name: 'ordersDetailsSlice',
  initialState,
  reducers: {
    setDateStart: (state, action) => {
      state.infoOrderDetail.date_start = action.payload;
    },
    setDateEnd: (state, action) => {
      state.infoOrderDetail.date_end = action.payload;
    },
    setInfoOrderDetail: (state, action) => {
      const { key, value } = action.payload;
      state.infoOrderDetail[key] = value;
    },
    setEmployedsInfo: (state, action) => {
      state.employedInfo = action.payload;
    },
    setInfoDateHourMinutes: (state, action) => {
      if (action.payload.key === 'date_start') {
        state.dateStartHourMinutes.hour = action.payload.value.slice(0, 2);
        state.dateStartHourMinutes.minutes = action.payload.value.slice(3);
      } else {
        state.dateEndHourMinutes.hour = action.payload.value.slice(0, 2);
        state.dateEndHourMinutes.minutes = action.payload.value.slice(3);
      }
    },
    setDateHourMinutes: (state, action) => {
      if (action.payload.position === 'left') {
        state.dateStartHourMinutes = {
          ...state.dateStartHourMinutes,
          [action.payload.key]: action.payload.value,
        };
      } else {
        state.dateEndHourMinutes = {
          ...state.dateEndHourMinutes,
          [action.payload.key]: action.payload.value,
        };
      }
    },
    resetOrderInfo: (state) => {
      state.infoOrderDetail = createInitialOrderDetail();
      state.employedInfo = {
        name: '',
        inn: '',
        status: 1,
        phone: '',
      };
      state.dateStartHourMinutes = {
        hour: '00',
        minutes: '00',
      };
      state.dateEndHourMinutes = {
        hour: '00',
        minutes: '00',
      };
    },
    updateFastWithdrawalDefault: (state, action: PayloadAction<boolean>) => {
      try {
        localStorage.setItem(
          'profile_settings',
          JSON.stringify({ use_fast_withdraw: action.payload }),
        );
      } catch (e) {
        console.log('Ошибка при сохранении настроек в localStorage', e);
      }
    },
  },
});

export const {
  setDateStart,
  setDateEnd,
  setInfoOrderDetail,
  setEmployedsInfo,
  setInfoDateHourMinutes,
  setDateHourMinutes,
  resetOrderInfo,
  updateFastWithdrawalDefault,
} = ordersDetailsSlice.actions;
export default ordersDetailsSlice.reducer;
